module.exports = __webpack_public_path__ + "static/img/3.fa0ba52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/zh/3.png
// module id = ph5Z
// module chunks = 0